import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { EsitoMeritoForm } from '../../../form/esito-merito-form';
import { DettaglioEsito } from '../../../models/dettaglio-esito';
import { Esito } from '../../../models/esito';

@Component({
    selector: 'div [esito-merito-form-update]',
  templateUrl: '../../../form/esiti-merito-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class EsitiMeritoUpdate extends EsitoMeritoForm implements OnInit {

  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  private idEsito: string;
  private esito: Esito;
  private updateUrl: string;
  private originalDettaglioEsito: DettaglioEsito;
  private modalNotifyService: ModalNotifyService;
  private idSezioneEsiti: string;
  private urlSezioneEsiti: string;

  constructor(@Inject(HelpersService) helpers: HelpersService,
              @Inject(OperationsService) operationService,
              @Inject(FormBuilder) campiForm,
              @Inject(ModalNotifyService) modalNotifyService) {
        super(helpers, operationService, campiForm);
        this.modalNotifyService = modalNotifyService; }

  ngOnInit() {
    this.setTitle('Modifica Dettaglio esito');
    this.isInserimento(false);
  }

  inizializza(idSezioneEsiti: string,
    urlSezioneEsiti: string,
              updateUrl: string,
              esito: Esito,
              dettaglioEsito: DettaglioEsito,
              urlSezioneControparti: string,
              idSezioneControparti: string,
              urlSezioneClassificazioni: string,
              idSezioneClassificazione: string,
              idPratica: string,
              ) {
    this.idSezioneEsiti = idSezioneEsiti;
    this.urlSezioneEsiti = urlSezioneEsiti;
    this.idEsito = esito.id;
    this.esito = esito;
    this.updateUrl = updateUrl;
    this.originalDettaglioEsito = dettaglioEsito;
    this.populateSelect(urlSezioneControparti, idSezioneControparti, urlSezioneClassificazioni, idSezioneClassificazione);
    this.readClassificazioni(idPratica);
    this.createForm();
  }

  getMeritoEsito(): DettaglioEsito {
    return this.originalDettaglioEsito;
  }

  getRequest(dettaglioEsito: DettaglioEsito) {
     this.operationsService.updateEsito(this.updateUrl, this.idEsito, this.idSezioneEsiti, dettaglioEsito).subscribe((response:any) => this.returnSetSezEsitiOrdinario());
  }

  returnSetSezEsitiOrdinario() {
    this.operationsService.readSezione(this.urlSezioneEsiti, this.idSezioneEsiti).subscribe(response=>{
        this.onReturn.emit(response.sezione);
    })
  }
}
